export enum ClinicStatesEnum {
    OPEN = "OPEN",
    CHAIRS_FULL = "AVAILABLE CHAIRS FULL",
    WEEK_SIX_GATEWAY = "WEEK 6 - GATEWAY",
    WEEK_SIX_REMEDIATION = "WEEK 6 - REMEDIATION",
  }

export enum ClinicsEnum {
    OMFS = "OMFS",
    ENDO = "Endo",
    SAME_DAY_CROWN = "CAD/CAM",
    HOME = "Home",
    PROSTH = "Prosth",
    PERIO = "Perio",
  }